import { useRef, useState } from "react";

import { Box, Button, Stack, Typography } from "@mui/material";
import AddBoxIcon from "@mui/icons-material/AddBox";
import { userState } from "../../interface/MainInterface";
import Toast from "../../utils/Toast";
import { GridColDef } from "@mui/x-data-grid";
import ReservationHealthAdmin from "../mobilePage/ReservationHealthAdmin";
import ReservationGolfAdmin from "../mobilePage/ReservationGolfAdmin";
import ReservationStudyAdmin from "../mobilePage/ReservationStudyAdmin";
import ReservationLockerAdmin from "../mobilePage/ReservationLockerAdmin";
import ReservationRobotCleanerAdmin from "../mobilePage/ReservationRobotCleanerAdmin";
import AdminReservationUserSearch from "./components/AdminReservationUserSearch";
interface propsType {
  userState: userState;
}

const AdminReservPage = (props: propsType) => {
  const toastRef: any = useRef();
  const [viewReserv, setViewReserv] = useState("");

  const handleClose = () => {
    setViewReserv("");
  };

  const [userInfo, setUserInfo] = useState<userState>(props.userState);
  const renderHealthButton = (params: any) => (
    <Button color="primary" onClick={() => handleHealth(params.row)}>
      <AddBoxIcon />
    </Button>
  );

  const handleHealth = async (params: any) => {
    setUserInfo(params);
    setViewReserv("health");
  };

  const renderGolfButton = (params: any) => (
    <Button color="primary" onClick={() => handleGolf(params.row)}>
      <AddBoxIcon />
    </Button>
  );

  const handleGolf = async (params: any) => {
    setUserInfo(params);
    setViewReserv("golf");
  };
  const renderStudyButton = (params: any) => (
    <Button color="primary" onClick={() => handleStudy(params.row)}>
      <AddBoxIcon />
    </Button>
  );
  const handleStudy = async (params: any) => {
    setUserInfo(params);
    setViewReserv("study");
  };
  const renderLockerButton = (params: any) => (
    <Button color="primary" onClick={() => handleLocker(params.row)}>
      <AddBoxIcon />
    </Button>
  );
  const handleLocker = async (params: any) => {
    setUserInfo(params);
    setViewReserv("locker");
  };
  const renderRobotCleanerButton = (params: any) => (
    <Button color="primary" onClick={() => handleRobotCleaner(params.row)}>
      <AddBoxIcon />
    </Button>
  );
  const handleRobotCleaner = async (params: any) => {
    setUserInfo(params);
    setViewReserv("robotCleaner");
  };

  const renderActionColumns = (): GridColDef[] => [
    {
      field: "userchLevel",
      headerName: "헬스장",
      width: 110,
      editable: false,
      renderCell: renderHealthButton,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "fingerUpdate",
      headerName: "골프연습장",
      width: 110,
      editable: false,
      renderCell: renderGolfButton,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "userchDefer",
      headerName: "독서실",
      width: 110,
      editable: false,
      renderCell: renderStudyButton,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "resetPassword",
      headerName: "락커",
      width: 150,
      renderCell: renderLockerButton,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "robotCleaner",
      headerName: "창문 로봇청소기",
      width: 160,
      renderCell: renderRobotCleanerButton,
      align: "center",
      headerAlign: "center",
    },
  ];
  return (
    <>
      <Stack
        direction={"column"}
        spacing={2}
        sx={{ p: "32px", pb: "16px !important" }}
      >
        <Box className="sub-header-root" sx={{ marginBottom: 4 }}>
          <Typography variant="h5" gutterBottom className="sub-header-title">
            회원 예약 관리
          </Typography>
        </Box>
        <Box sx={{ flexGrow: 1 }}>
          <AdminReservationUserSearch
            userState={props.userState}
            selectLevel="회원"
            onSearchSuccess={() => setViewReserv("")}
            renderActionColumns={renderActionColumns}
          />
        </Box>
      </Stack>
      {viewReserv === "health" && (
        <ReservationHealthAdmin
          userState={props.userState}
          userInfo={userInfo}
          handleClose={handleClose}
        />
      )}
      {viewReserv === "golf" && (
        <ReservationGolfAdmin
          userState={props.userState}
          userInfo={userInfo}
          handleClose={handleClose}
        />
      )}
      {viewReserv === "study" && (
        <ReservationStudyAdmin
          userState={props.userState}
          userInfo={userInfo}
          handleClose={handleClose}
        />
      )}
      {viewReserv === "locker" && (
        <ReservationLockerAdmin
          userState={props.userState}
          userInfo={userInfo}
          handleClose={handleClose}
        />
      )}
      {viewReserv === "robotCleaner" && (
        <ReservationRobotCleanerAdmin
          userState={props.userState}
          userInfo={userInfo}
          handleClose={handleClose}
        />
      )}

      <Toast ref={toastRef} />
    </>
  );
};

export default AdminReservPage;
